import Repository from '../Repository';

const url = '/admin/equipment-orders';

export default {

    getAllShippedEquipmentOrders(page) {
        return Repository.get(`${url}/shipped?page=${page}`);
    },

    getAllNotShippedEquipmentOrders(page) {
        return Repository.get(`${url}/not-shipped?page=${page}`);
    },

    sendEquipment(equipmentOrder){
        return Repository.patch(`${url}/${equipmentOrder}`)
    }

}